import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<any> {

    static about = `
Make an infoviewer page event look like a feature click event.

Usage Example:

    <EVENT about="When paging occurs treat that as if the user clicked the associated feature" event="show-info-handler-controller" id="synthetic-click" mid="app/commands/infoviewer-paging-as-feature-click-event">
    <OPTIONS>
        <Values about="highlight the feature each time the user pages" id="event" value="flash-buffer" />
        <Values id="debug" value="false" />
    </OPTIONS>
    </EVENT>

`;

    static output = {
        "feature": {
            "about": "the active infoviewer feature",
        },
    };

    execute(args: any = this.args) {
        let activeFeature = this.findOption("activeFeature");
        if (activeFeature) {
            this.trigger({
                feature: activeFeature
            });
        }
    }

}

export = Command; 